import { Component, OnInit } from '@angular/core';
import { OktaAuthService } from 'src/app/services/OktaAuth/okta-auth.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {

  constructor(
    private okta: OktaAuthService
    ) {}

  async ngOnInit(): Promise<void> {
    // Handles the response from Okta and parses tokens
    await this.okta.handleAuthentication();
  }
}
